import { render, staticRenderFns } from "./NumberHero.vue?vue&type=template&id=46a9c202&scoped=true"
import script from "./NumberHero.vue?vue&type=script&lang=js"
export * from "./NumberHero.vue?vue&type=script&lang=js"
import style0 from "./NumberHero.vue?vue&type=style&index=0&id=46a9c202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a9c202",
  null
  
)

export default component.exports